'use client';
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Platform, Text as RNText, StyleSheet, View } from "react-native";
import { useTheme } from "../../styles";
/**
 * Renders the provided string content to the screen. Comes with preset styles
 * as determined by the theme but also allows customization of various style
 * attributes.
 *
 *
 *
 * {@adf 💾̀̀̇̋̀̀̂̂̀̀̇̄̀̀̇̉̀̀̇̀̀̀̆̅̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̍̀̀̆̅̀̀̆̄̀̀̆̉̀̀̆́̀̀̅̃̀̀̆̉̀̀̆̎̀̀̆̇̀̀̆̌̀̀̆̅̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆́̀̀̇̄̀̀̇̄̀̀̇̂̀̀̇̃̀̀̂̂̀̀̃̊̀̀̇̋̀̀̂̂̀̀̆̌̀̀̆́̀̀̇̉̀̀̆̏̀̀̇̅̀̀̇̄̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆́̀̀̆̌̀̀̆̉̀̀̆̇̀̀̆̎̀̀̂̍̀̀̇̃̀̀̇̄̀̀̆́̀̀̇̂̀̀̇̄̀̀̂̂̀̀̇̍̀̀̂̌̀̀̂̂̀̀̆̃̀̀̆̏̀̀̆̎̀̀̇̄̀̀̆̅̀̀̆̎̀̀̇̄̀̀̂̂̀̀̃̊̀̀̅̋̀̀̇̋̀̀̂̂̀̀̇̄̀̀̇̉̀̀̇̀̀̀̆̅̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̍̀̀̆̅̀̀̆̄̀̀̆̉̀̀̆́̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆́̀̀̇̄̀̀̇̄̀̀̇̂̀̀̇̃̀̀̂̂̀̀̃̊̀̀̇̋̀̀̂̂̀̀̇̄̀̀̇̉̀̀̇̀̀̀̆̅̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̆̀̀̆̉̀̀̆̌̀̀̆̅̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆̉̀̀̆̄̀̀̂̂̀̀̃̊̀̀̂̂̀̀̃̈̀̀̃̅̀̀̃̂̀̀̃́̀̀̃̉̀̀̃̃̀̀̆́̀̀̃̈̀̀̂̍̀̀̆̅̀̀̃̆̀̀̆̆̀̀̃̄̀̀̂̍̀̀̃̄̀̀̃̂̀̀̃̀̀̀̆̂̀̀̂̍̀̀̆́̀̀̃̄̀̀̃̉̀̀̆́̀̀̂̍̀̀̃́̀̀̃̃̀̀̆̆̀̀̃̄̀̀̆́̀̀̃̈̀̀̃̈̀̀̆̅̀̀̆̄̀̀̆̃̀̀̃̅̀̀̃̂̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆́̀̀̆̌̀̀̇̄̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̉̀̀̆̍̀̀̆́̀̀̆̇̀̀̆̅̀̀̂̍̀̀̃̂̀̀̃̀̀̀̃̂̀̀̃̅̀̀̃̀̀̀̃̃̀̀̃̃̀̀̃́̀̀̂̍̀̀̃́̀̀̃̈̀̀̃̅̀̀̃̈̀̀̃̄̀̀̃̆̀̀̂̎̀̀̇̀̀̀̆̎̀̀̆̇̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆̃̀̀̆̏̀̀̆̌̀̀̆̌̀̀̆̅̀̀̆̃̀̀̇̄̀̀̆̉̀̀̆̏̀̀̆̎̀̀̂̂̀̀̃̊̀̀̂̂̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆̈̀̀̆̅̀̀̆̉̀̀̆̇̀̀̆̈̀̀̇̄̀̀̂̂̀̀̃̊̀̀̃̃̀̀̃̅̀̀̃́̀̀̂̌̀̀̂̂̀̀̇̇̀̀̆̉̀̀̆̄̀̀̇̄̀̀̆̈̀̀̂̂̀̀̃̊̀̀̃̆̀̀̃̆̀̀̃̆̀̀̇̍̀̀̇̍̀̀̅̍̀̀̇̍}
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-44}
 */ export var Text = /*#__PURE__*/ forwardRef(function Text(param, ref) {
    var accessibilityHint = param.accessibilityHint, ariaLabel = param['aria-label'], ariaLive = param['aria-live'], role = param.role, children = param.children, color = param.color, italic = param.italic, lineHeight = param.lineHeight, numberOfLines = param.numberOfLines, onLayout = param.onLayout, size = param.size, strikethrough = param.strikethrough, style = param.style, testID = param.testID, text = param.text, textAlign = param.textAlign, weight = param.weight;
    var theme = useTheme().theme;
    var fontSize = size !== null && size !== void 0 ? size : theme.typography.body.size;
    lineHeight = typeof size === 'number' && typeof lineHeight !== 'number' ? size * 1.4 : lineHeight !== null && lineHeight !== void 0 ? lineHeight : theme.typography.body.lineHeight;
    var inner = /*#__PURE__*/ _jsx(RNText, {
        accessibilityHint: accessibilityHint,
        "aria-label": ariaLabel,
        "aria-live": ariaLive,
        role: role,
        id: testID,
        testID: testID,
        ref: ref,
        numberOfLines: numberOfLines,
        onLayout: onLayout,
        style: [
            {
                textAlign: textAlign,
                color: color || theme.color.gray100,
                fontFamily: global.fontsLoaded || Platform.OS === 'web' ? weight === 'bold' ? 'OpenSansBold' : weight === 'semibold' ? 'OpenSansSemiBold' : 'OpenSansRegular' : undefined,
                fontSize: fontSize,
                lineHeight: lineHeight
            },
            style,
            italic ? {
                fontStyle: 'italic',
                fontFamily: undefined
            } : null,
            strikethrough ? {
                textDecorationLine: 'line-through',
                textDecorationStyle: 'solid'
            } : null
        ],
        children: text || children || ''
    });
    // accessibilityElementsHidden doesn't work on text elements, so if we want to hide this on iOS
    // we need to wrap in a View
    if (role === 'none') {
        var _StyleSheet_flatten;
        return /*#__PURE__*/ _jsx(View, {
            "aria-hidden": true,
            style: {
                flex: (_StyleSheet_flatten = StyleSheet.flatten(style)) === null || _StyleSheet_flatten === void 0 ? void 0 : _StyleSheet_flatten.flex
            },
            children: inner
        });
    }
    return inner;
});
/**
 * @nosync
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-44}
 */ export function ThemeText(props) {
    var fontTheme = props.fontTheme;
    return /*#__PURE__*/ _jsx(Text, _object_spread({}, fontTheme, props));
}
/**
 * @nosync
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-44}
 */ export function Lead(props) {
    var theme = useTheme().theme;
    var fontTheme = theme.typography.lead;
    return /*#__PURE__*/ _jsx(ThemeText, _object_spread({
        fontTheme: fontTheme
    }, props));
}
/**
 * @nosync
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-44}
 */ export function Heading(props) {
    var theme = useTheme().theme;
    var fontTheme = theme.typography["heading".concat(props.level)];
    var variantColor = props.variant === 'light' ? theme.color.gray800 : theme.color.dark;
    var _props_color, _ref;
    return /*#__PURE__*/ _jsx(ThemeText, _object_spread_props(_object_spread({
        fontTheme: fontTheme
    }, props), {
        color: (_ref = (_props_color = props.color) !== null && _props_color !== void 0 ? _props_color : fontTheme.color) !== null && _ref !== void 0 ? _ref : variantColor,
        role: "heading"
    }));
}
/**
 * @nosync
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-44}
 */ export function Label(props) {
    var theme = useTheme().theme;
    var fontTheme = theme.typography.label;
    return /*#__PURE__*/ _jsx(ThemeText, _object_spread_props(_object_spread({
        fontTheme: fontTheme
    }, props), {
        size: props.small ? 15 : undefined
    }));
}
/**
 * @nosync
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-44}
 */ export function Small(props) {
    var theme = useTheme().theme;
    var fontTheme = theme.typography.small;
    return /*#__PURE__*/ _jsx(ThemeText, _object_spread({
        fontTheme: fontTheme
    }, props));
}
/**
 * @nosync
 * @deprecated
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-44}
 */ export function OldHeading(_param) {
    var style = _param.style, props = _object_without_properties(_param, [
        "style"
    ]);
    var theme = useTheme().theme;
    return /*#__PURE__*/ _jsx(Text, _object_spread_props(_object_spread({}, props), {
        size: 22,
        lineHeight: 28,
        color: theme.color.dark,
        weight: "bold",
        style: [
            {
                marginBottom: 4
            },
            style
        ],
        role: "heading"
    }));
}
/**
 * @nosync
 * @deprecated
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-44}
 */ export function OldSubheading(_param) {
    var style = _param.style, props = _object_without_properties(_param, [
        "style"
    ]);
    return /*#__PURE__*/ _jsx(Text, _object_spread_props(_object_spread({}, props), {
        size: 16,
        lineHeight: 18,
        weight: "bold",
        style: [
            {
                marginBottom: 4
            },
            style
        ],
        role: "heading"
    }));
}
